import {BaseModel} from "./base.model";

export interface PostCategory {
	id: string,
	name: string,
	status: boolean,
	order_number: number,
	thumbnail: string
}

class PostCategoriesModel extends BaseModel {
	protected collectionName = 'post_categories'

	private static _instance: PostCategoriesModel

	public static get Instance() {
		return this._instance || (this._instance = new this())
	}
}

export default PostCategoriesModel.Instance